(() => {
  if (customElements.get('orli-mystery-offer')) return;
  class OrliMysteryOffer extends HTMLElement {
    static busy = false;
    static syncing = null;
    static pending = false;
    static productId = '15999313052021';
    static hasJewellery(cart) {
      return cart.items.some(item => {
        const identity = [item.product_type, item.product_title, item.title, item.handle].filter(Boolean).join(' ');
        return item.quantity > 0 && item.requires_shipping && !item.gift_card &&
          !['15999313052021', '15547237171573'].includes(String(item.product_id)) &&
          !/gift[\s-]*(?:wrap|wrapping|card|bag|box|message)|wrapin|polishing[\s-]*cloth|packaging/i.test(identity) &&
          /\b(?:bracelets?|bangles?|necklaces?|earrings?|rings?|anklets?|charms?|chains?|pendants?|jewellery|jewelry)\b/i.test(identity);
      });
    }
    static async synchronize() {
      if (this.busy) return;
      if (this.syncing) { this.pending = true; return this.syncing; }
      this.syncing = (async () => {
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Cart unavailable');
          let cart = await response.json();
          const mystery = cart.items.filter(item => String(item.product_id) === this.productId);
          if (mystery.length && !this.hasJewellery(cart)) {
            const updates = Object.fromEntries(mystery.map(item => [item.key, 0]));
            const removal = await fetch(root + 'cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates })
            });
            if (!removal.ok) throw new Error('Cart unavailable');
            cart = await removal.json();
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          }
          document.querySelectorAll('orli-mystery-offer').forEach(offer => {
            if (!offer.previewDone) offer.hidden = cart.currency !== 'GBP' || !this.hasJewellery(cart) || offer.hasMystery(cart) || offer.select.options.length < 2;
            offer.onChange();
          });
        } catch {
          document.querySelectorAll('orli-mystery-offer').forEach(offer => { offer.hidden = true; });
        }
      })();
      try { await this.syncing; } finally {
        this.syncing = null;
        if (this.pending) { this.pending = false; this.synchronize(); }
      }
    }
    connectedCallback() {
      this.select = this.querySelector('[data-mystery-finish]');
      this.button = this.querySelector('[data-mystery-add]');
      this.status = this.querySelector('[data-mystery-status]');
      this.onChange = () => { this.button.disabled = !this.select.value || OrliMysteryOffer.busy; };
      this.onAdd = () => this.add();
      this.select.addEventListener('change', this.onChange);
      this.button.addEventListener('click', this.onAdd);
      this.refresh();
    }
    disconnectedCallback() {
      this.select.removeEventListener('change', this.onChange);
      this.button.removeEventListener('click', this.onAdd);
    }
    root() { return window.Shopify?.routes?.root || '/'; }
    async cart() {
      const response = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }
    hasMystery(cart) { return cart.items.some(item => String(item.product_id) === this.dataset.productId); }
    hasJewellery(cart) {
      return OrliMysteryOffer.hasJewellery(cart);
    }
    async refresh() {
      if (this.previewDone || !this.isConnected) return;
      await OrliMysteryOffer.synchronize();
    }
    async add() {
      if (!this.select.value || OrliMysteryOffer.busy) return;
      if (this.dataset.preview === 'true') {
        this.previewDone = true;
        this.querySelector('.orli-mystery__card').hidden = true;
        this.status.textContent = this.dataset.previewAdded;
        return;
      }
      OrliMysteryOffer.busy = true;
      this.button.disabled = true;
      this.status.textContent = '';
      try {
        const cart = await this.cart();
        if (this.hasMystery(cart) || !this.hasJewellery(cart)) { this.hidden = true; return; }
        const response = await fetch(this.root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.select.value), quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.dataset.error);
        this.hidden = true;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      } catch {
        this.status.textContent = this.dataset.error;
      } finally {
        OrliMysteryOffer.busy = false;
        document.querySelectorAll('orli-mystery-offer').forEach(offer => offer.onChange());
        OrliMysteryOffer.synchronize();
      }
    }
  }
  customElements.define('orli-mystery-offer', OrliMysteryOffer);
  document.addEventListener('theme:cart:change', () => OrliMysteryOffer.synchronize());
  document.addEventListener('theme:product:added', () => OrliMysteryOffer.synchronize());
  window.addEventListener('pageshow', () => OrliMysteryOffer.synchronize());
})();
